/**
 * GALLERY_LIGHTBOX モジュール
 * - 指定された要素内のすべての <a> タグに data-lightbox 属性を追加
 * - 対応例：Lightbox2などのJSライブラリ用
 */
export const GALLERY_LIGHTBOX = {
  /**
   * @param {string} selector - 対象となるCSSセレクタ文字列（例: '[id^="gallery"]'）
   */
  init(selector) {
    const galleries = document.querySelectorAll(selector)

    galleries.forEach((gallery, index) => {
      const links = gallery.querySelectorAll('a')
      links.forEach(link => {
        link.setAttribute('data-lightbox', `group-${index + 1}`)
      })
    })
  },
}
